var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "raciocinio-linha mb-3",
      attrs: { "data-teste": "raciocinio-linha" }
    },
    [
      _c(
        "button",
        {
          staticClass:
            "raciocinio-linha__botao d-inline-flex align-center text-left pa-0",
          class: _vm.classesDoBotao,
          attrs: {
            type: "button",
            "aria-expanded": _vm.ariaExpanded,
            disabled: !_vm.expansivel,
            "data-teste": "raciocinio-linha-botao"
          },
          on: { click: _vm.alternar }
        },
        [
          _c("IndicadorDeAtividade", {
            staticClass: "raciocinio-linha__icone mr-2",
            attrs: {
              modo: _vm.modoDoIndicador,
              cor: _vm.corDoIcone,
              "data-teste": "raciocinio-linha-indicador"
            }
          }),
          _c(
            "span",
            {
              staticClass:
                "raciocinio-linha__conteudo d-inline-flex align-baseline"
            },
            [
              _c(
                "span",
                { staticClass: "raciocinio-linha__caixa" },
                [
                  _c(
                    "transition",
                    { attrs: { name: "iv2-passo", mode: "out-in" } },
                    [
                      _c(
                        "span",
                        {
                          key: _vm.texto,
                          staticClass:
                            "raciocinio-linha__texto az-text-primary az-size-14",
                          class: _vm.classesDoTexto,
                          attrs: { "data-teste": "raciocinio-linha-texto" }
                        },
                        [_vm._v(_vm._s(_vm.texto))]
                      )
                    ]
                  )
                ],
                1
              ),
              _vm.auxiliarDaLinha
                ? _c(
                    "span",
                    {
                      staticClass:
                        "raciocinio-linha__auxiliar az-ds-aux flex-shrink-0 ml-2",
                      attrs: { "data-teste": "raciocinio-linha-auxiliar" }
                    },
                    [_vm._v(_vm._s(_vm.auxiliarDaLinha))]
                  )
                : _vm._e()
            ]
          ),
          _vm.expansivel
            ? _c("icon-svg", {
                staticClass: "raciocinio-linha__chevron flex-shrink-0 ml-1",
                class: { "raciocinio-linha__chevron--aberto": _vm.aberta },
                attrs: {
                  name: _vm.ICONE_DO_CHEVRON,
                  size: _vm.TAMANHO_DO_CHEVRON,
                  color: "var(--neutral-700)"
                }
              })
            : _vm._e()
        ],
        1
      ),
      _c(
        "output",
        {
          staticClass: "raciocinio-linha__anuncio",
          attrs: { "aria-live": "polite" }
        },
        [_vm._v(_vm._s(_vm.texto))]
      ),
      _vm.mostraLista
        ? _c(
            "transition-group",
            {
              tag: "ul",
              staticClass: "raciocinio-linha__lista az-gap-xsmall mt-1 mb-0",
              attrs: {
                name: "iv2-parte",
                "aria-label": _vm.ariaLista,
                "data-teste": "raciocinio-linha-lista"
              }
            },
            _vm._l(_vm.grupos, function(item) {
              return _c(
                "li",
                {
                  key: item.chave,
                  staticClass:
                    "raciocinio-linha__passo d-flex align-baseline py-0 mr-0"
                },
                [
                  _c(
                    "span",
                    {
                      staticClass:
                        "raciocinio-linha__passo-texto ia-texto-raciocinio-passo"
                    },
                    [
                      item.verbo
                        ? _c(
                            "span",
                            {
                              staticClass: "raciocinio-linha__passo-verbo",
                              attrs: {
                                "data-teste": "raciocinio-linha-passo-verbo"
                              }
                            },
                            [_vm._v(_vm._s(item.verbo) + " ")]
                          )
                        : _vm._e(),
                      item.complemento
                        ? _c(
                            "span",
                            {
                              staticClass:
                                "raciocinio-linha__passo-complemento",
                              attrs: {
                                "data-teste":
                                  "raciocinio-linha-passo-complemento"
                              }
                            },
                            [_vm._v(_vm._s(item.complemento))]
                          )
                        : _vm._e()
                    ]
                  ),
                  item.meta
                    ? _c(
                        "span",
                        {
                          staticClass: "az-ds-aux ml-2 flex-shrink-0",
                          attrs: { "data-teste": "raciocinio-linha-passo-meta" }
                        },
                        [_vm._v("· " + _vm._s(item.meta))]
                      )
                    : _vm._e()
                ]
              )
            }),
            0
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }